module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-04-27 at 21.26.55 - Copy.8f25f17b.jpeg";